import { useEffect, useState } from 'react';

/** Reports which of the given element ids is currently most in view, for TOC active-state highlighting. */
export function useScrollSpy(ids: string[]): string | null {
  const [activeId, setActiveId] = useState<string | null>(ids[0] ?? null);

  useEffect(() => {
    const elements = ids
      .map((id) => document.getElementById(id))
      .filter((el): el is HTMLElement => el !== null);
    if (elements.length === 0) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const [first] = entries.filter((entry) => entry.isIntersecting);
        if (first) {
          setActiveId(first.target.id);
        }
      },
      { rootMargin: '-10% 0px -70% 0px', threshold: 0 },
    );
    elements.forEach((el) => {
      observer.observe(el);
    });
    return () => observer.disconnect();
  }, [ids]);

  return activeId;
}
